import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
import { COLOR, HEALTHSCORECOLOR, GRAPH_COLOR } from '@common/constants'
import moment from 'moment-timezone'

export default ({ dataSeries }) => {

    const setLowHighOnGraph = (ctx, config) => {
        var lowest = ctx.getLowestValueInSeries(0)
        var highest = ctx.getHighestValueInSeries(0)

        ctx.addPointAnnotation
            ({
                x: new Date(ctx.w.globals.seriesX[0][ctx.w.globals.series[0].indexOf(lowest)]).getTime(),
                y: lowest,
                label:
                {
                    text: 'Lowest: ' + lowest,
                    offsetY: 2
                },
            })
        ctx.addPointAnnotation
            ({
                x: new Date(ctx.w.globals.seriesX[0][ctx.w.globals.series[0].indexOf(highest)]).getTime(),
                y: highest,
                label: {
                    text: 'Highest: ' + highest,
                    offsetY: 2
                },
            })
    }


    return (
        <ReactApexChart
            options={{
                ...defaultChartOption,
                chart: {
                    id: 'healthScore-chart', group: 'historical-page-chart', type: 'bar',
                    events: { mounted: setLowHighOnGraph }
                },
                stroke: { width: 1 },
                plotOptions: { bar: { columnWidth: '100%', rangeBarOverlap: true, } },
                colors:
                    [
                        function ({ value, seriesIndex, w }) {
                            if (value < 20) return HEALTHSCORECOLOR.DANGER
                            else if (value >= 20 && value < 40) return HEALTHSCORECOLOR.UNHEALTHY
                            else if (value >= 40 && value < 60) return HEALTHSCORECOLOR.HIGHRISK
                            else if (value >= 60 && value < 80) return HEALTHSCORECOLOR.RISK
                            else return HEALTHSCORECOLOR.HEALTHY
                        }
                    ],
                yaxis: healthScoreYaxis,

            }}
            series={dataSeries}
            height={180}
            type='bar'
        />
    )
}



const defaultChartOption = {
    chart: {
        height: 350,
        animations: { enabled: true },
        autoScaleYaxis: true
    },
    dataLabels: {
        enabled: false
    },
    markers: { size: 0 },
    legend: {
        show: false,
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 20
    },
    xaxis: {
        type: 'datetime',
        labels: {
            datetimeUTC : false,
            style: {
                colors: COLOR.DARKGREY,
            }
        }
    },
    tooltip: {
        x: {
            format: 'dd/MM/yy HH:mm',
        },
    },
    grid: {
        yaxis: {
            lines: {
                offsetX: -10,
                show: true
            },
        },
        xaxis: {
            lines: {
                show: true,
            },
            labels: {
                style: {
                    colors: COLOR.DARKGREY,
                },
                offsetY: 0,
                offsetX: 0,
                axisBorder: {
                    show: true,
                },
            },
        },
        padding: {
            left: 20,
            Right: 45
        },
        strokeDashArray: 5,
    },
}

const healthScoreYaxis = {
    min: 4,
    max: 100,
    floating: false,
    labels: {
        style: {
            colors: COLOR.DARKGREY,
        },
    },
    axisBorder: {
        show: true,
    },
    axisTicks: {
        show: true,
    },
    title: {
        text: 'Health Score (%)',
        style: { color: COLOR.TMD_GREY }
    }
}